<template>
  <section>
        <b-card 
        style="width:100%">   
          <template v-slot:header >
            <div class="header-card">
              Ordenes Pendientes
            </div>
          </template>
            <b-form  inline style="margin-bottom:15px;" novalidate >
              <b-row style="width:100%">  
                <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                     dataBackend
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="orden_table"
                    route="ordenes_pendientes"
                    dataRoute="ord_datosorden"
                    >
                      <template v-slot:modal>
                      <sw-modalregistroorden
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm"
                        >
                      </sw-modalregistroorden> 
                      <sw-modalrecibirorden
                        v-if="openModal.modal.modal==='Recibir'"
                        @save="saveForm"
                        >
                      </sw-modalrecibirorden> 
                      <sw-modalabonos
                        v-if="openModal.modal.modal==='Abonar'"
                        @save="saveForm"
                        >
                      </sw-modalabonos>                     
                      <sw-modalentrega
                        v-if="openModal.modal.modal==='Entregar'"
                        @save="saveForm"
                        >
                      </sw-modalentrega>  
                    </template>
                  </sw-tableget>                  
                </b-col>                                     
              </b-row>             
           </b-form>                
         </b-card>  
  </section>
</template>

<script>
import SwSaveform from '@/components/forms/saveForm.vue'
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalabonos from '@/components/modals/abonos.vue'
import SwModalentrega from '@/components/modals/entrega.vue'
import SwModalrecibirorden from '@/components/modals/recibirorden.vue'
import SwModalregistroorden from '@/components/modals/registroorden.vue'

export default { 
  name: "ord_datosorden",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
     SwInputs,
     ValidationObserver,     
     SwSaveform,
     SwTableget,
     SwModalentrega,
     SwModalabonos,
     SwModalrecibirorden,
     SwModalregistroorden     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>
